// extracted by mini-css-extract-plugin
export var errorsContainer = "_tz-1";
export var link = "_tz-0";